import { Box, Typography } from "@mui/material";

import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";

export default function BoxBasketHistory({ basket }) {
  return (
    <Card marginBottom={15}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
        pb={2}
      >
        <Box display="flex" alignItems="center" flexDirection="row-reverse">
          <img
            src={DefaultUrlWeb + basket?.coinImageUrl}
            alt=""
            width={25}
          />
          <Typography variant="h5" color="text.main" pl={1}>
            {basket?.coinName}
          </Typography>
        </Box>

        <Box>
          {" "}
          <Typography variant="subtitle1" color="text.secondary">
            {basket?.date} {basket?.time}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="row-reverse" pb={2}>
        <Typography variant="h6" color="text.secondary">
          Amount
        </Typography>

        <Typography variant="h6" px={1}>
          {basket?.amount}
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row-reverse">
        <Typography variant="h6" color="text.secondary">
          type
        </Typography>

        <Typography variant="h6" pl={1}>
          {basket?.type}
        </Typography>
      </Box>
    </Card>
  );
}
